var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-banner',{staticClass:"text-center",attrs:{"two-line":""},on:{"click":_vm.alert}},[_c('p',{staticClass:"pa-0 ma-0 banner-text",on:{"click":_vm.alert}},[_vm._v("\n    Join our newsletter and receive a promo code for 10% off your next points\n    purchase!!\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2018e690","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = null
// module chunks = 